module.exports = __webpack_public_path__ + "img/Datum_500.6382352a.png";